import { auth } from '@/services/auth'
import { computed } from 'vue'

/** 権限を持つ管理者ロールのCODE */

export const ROLE_ADMIN = '9'

export const useIsAdmin = () => {
  const isAdmin = computed(() => {
    return auth.me.value?.user?.role_code === ROLE_ADMIN
  })
  return {
    isAdmin
  }
}
